import React from 'react';
import BaseClass from '../common/baseClass';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues, resetApplication } from "../../redux/actions"; //setter
import { filterSparePartsSelector } from "../../redux/selectors"; //getter
import ModalItem from '../views/ModalItem';

const common = require('../common/common');
const env = require("../../config.js").default;

class FilterSpareParts extends BaseClass {

	componentWillMount() {
		this.updateStateWithStoreProps();
	}

	componentDidMount() {
		const $ = window.$;
		$("#applicazioni_search").on(("change keyup"), (e) => {
			if (e.which === 10 || e.which === 13)
				this.searchApplications(e);
		});
	}

	resetApplications(e) {
		e.preventDefault();
		const $ = window.$;
		$("input#applicazioni_search").val("").focus();
		$("#erroreApplicazione").css("display", "none");
		if (!this.state.filtersState.cmoto || this.state.filtersState.applicazione) {
			$("#tavoleSelContainer").removeClass("select-focus");
			$("#modelSelContainer").removeClass("select-focus");
		}
		$("#ricerca_filtro_modello_pulse").removeClass("animate__animated animate__bounce");
		$("#ricerca_filtro_tavole_pulse").removeClass("animate__animated animate__bounce");

		const modello = this.state.filtersState.cmoto ? this.state.filtersState.cmoto : '';
		this.props.changeValues({ filtersState: { applicazione: '', tavola: '', modello: modello }, dataList: { applicazioni: [] }, renewMutex: { applicazioni: true, tavole: true } });
	}

	searchApplications(e) {
		e.preventDefault();
		const $ = window.$;
		var zprod = this.state.filtersState.marca;
		this.props.changeValues({ filtersState: { tavola: '' } });
		if ($("#applicazioni_search").val() === '') {
			$("input#applicazioni_search").addClass("is-invalid");
			$("input#applicazioni_search").attr("placeholder", common.getTrad("Inserisci il codice articolo..."));
		} else {
			var carti = $("#applicazioni_search").val().toUpperCase().trim();
			$("input#applicazioni_search").removeClass("is-invalid");
			if (this.state.renewMutex.applicazioni) {
				this.props.changeValues({ renewMutex: { applicazioni: false }, filtersState: { applicazione: carti } });
				this.handleCloseModal();
				common.apiCall(env.BACKEND + "epc/get_applications_part/", "GET", { zprod: zprod, carti: carti }, true).then((applicazioni) => {
					if (applicazioni.error !== false) {
						$("#erroreApplicazione").css("display", "block");
						$('#erroreApplicazione').html('<i class="fas fa-exclamation-triangle"></i> ' + common.getTrad("Nessuna corrispondenza trovata"));
					} else {
						$('#ricerca_filtro_modello .select_modelli').val('').trigger('change');
						this.props.changeValues({ dataList: { applicazioni: applicazioni }, renewMutex: { modelliApp: true }, filtersState: { applicazione: carti} });
					}
				});
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		this.updateStateWithStoreProps(nextProps);

	}

	handleCloseModal = () => {
		this.setState({ showModalItem: false });
	}

	render(props) {
		return (
			<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 row-eq-height " role="alert" id="ricerca_filtro_telaio">
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_filtro">
					<h4 id="label-applicazioni_search">{common.getTrad("Ricerca per Codice Articolo")}
						<figure className="svg" src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-veicoli.svg"} title={common.getTrad("Ricerca Modello")} alt={common.getTrad("Ricerca Modello")}></figure>
					</h4>
					<hr />
					<div className="input-group">
						<input readOnly={this.state.filtersState.applicazione ? true : false} name="applicazioni_search" id="applicazioni_search" aria-labelledby="label-applicazioni_search" className="form-control" type="text" maxLength="32" defaultValue={this.state.filtersState.applicazione} />
						<span className="input-group-btn bottone_ricerca">
							{this.state.filtersState.applicazione.length <= 0 ?
								<button onClick={e => this.searchApplications(e)} className="btn btn-light" type="button">
									<span className="fas fa-search"></span> {common.getTrad("Cerca")}
								</button>
								:
								<button id="btn_resetta" onClick={e => this.resetApplications(e)} className="btn btn-light"><span className="fas fa-redo"></span> {common.getTrad("Resetta")}</button>
							}
						</span>
					</div>
					<div style={{ display: 'none' }} id="erroreApplicazione" className="alert alert-warning mt-3" role="alert"></div>
				</div>
				<ModalItem arti={this.state.filtersState.applicazione}></ModalItem>
			</div>
		)
	}
}

const mapStateToProps = state => {
	const store = filterSparePartsSelector(state);
	return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, changeValues, resetApplication })(FilterSpareParts);
// export default FilterSpareParts;
